import { createSlice } from '@reduxjs/toolkit';
import { getAlertSettings } from '../../../rtk-apis/clinics/getAlertSettings';

export type AlertSettingsResult = {
  hospitalId: string;
  overdueAlertsEnabled: boolean;
  overdueThresholdDays: number;
  alertHour: number;
  isDefault: boolean;
} | null;

const initialState = {
  status: '',
  result: null as AlertSettingsResult,
  msg: '',
  loading: false,
};

const getAlertSettingsSlice = createSlice({
  name: 'getAlertSettings',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAlertSettings.pending, state => {
        state.loading = true;
      })
      .addCase(getAlertSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload?.result;
        state.msg = action?.payload?.msg;
      })
      .addCase(getAlertSettings.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default getAlertSettingsSlice.reducer;
export const { clearState } = getAlertSettingsSlice.actions;
